<template>
  <div>
    <app-form-holder>
      <!--  -->
      <app-form-title title="Forgotten your password?">
        No problem. Let us know where <br />
        to send the password reset email
      </app-form-title>
      <!--  -->
      <!-- Login form -->
      <div>
        <div v-if="sentInstructions">
          <ForgotEmailSent />
        </div>
        <!--  -->
        <el-form
          v-if="!sentInstructions"
          :rules="rules"
          @submit.prevent
          class="App-Styled-Form"
          :label-position="'top'"
          label-width="100px"
          :model="form"
          style="margin-top: 12px"
        >
          <!--  -->
          <!-- Email -->
          <el-form-item prop="email" label="Email">
            <template v-slot:label>
              <el-icon>
                <Message />
              </el-icon>
              Email
            </template>
            <el-input
              placeholder="johndoe@e4t.com"
              v-model="form.email"
            ></el-input>
          </el-form-item>
          <!--  -->
          <!--  -->
          <div txt-center>
            <el-button
              :disabled="!form.email"
              is-block
              size="large"
              type="primary"
              icon="el-icon-check"
              @click="submit"
            >
              Send reset email
            </el-button>
          </div>
        </el-form>
      </div>
      <!--  -->
      <!--  -->
      <el-divider />
      <!--  -->
      <!-- Other links -->
      <div txt-center>
        <el-space
          w-100
          :fill="true"
          alignment="center"
          direction="vertical"
          :size="4"
        >
          <div>
            <router-link to="/login">
              <el-link type="primary">Sign In</el-link>
            </router-link>
          </div>
          <div>
            <span>Don't have an account?</span>
          </div>
          <!--  -->
          <app-create-account-links> </app-create-account-links>
          <!--  -->
        </el-space>
      </div>
      <!--  -->
    </app-form-holder>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Message, Lock } from "@element-plus/icons";
import ForgotEmailSent from "./forgot-email-sent.vue";
import { ErrorUtil } from "@/shared";

@Options({
  title: "Forgot Password",
  components: { Message, Lock, ForgotEmailSent },
})
export default class extends Vue {
  /**
   * Form data
   */
  form = { email: undefined, password: undefined };
  loading = false;
  rules = {
    email: [
      { required: true, message: "Email is required!", trigger: "blur" },
      {
        type: "email",
        message: "Please input correct email address",
        trigger: ["blur", "change"],
      },
    ],
  };

  sentInstructions = false;
  /**
   * @sends the submit request to the API
   */
  submit(): void {
    this.loading = true;
    this.$api.main
      .post("/v1/auth/forgot", this.form)
      .then((resp) => {
        this.sentInstructions = true;
        this.$message({
          duration: ErrorUtil.duration,
          type: "success",
          message: "Sent password reset email.",
        });
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: "Failed to send password reset email.",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
</script>

<style lang="scss"></style>
